import axios from "axios";
import Cookies from "js-cookie";


axios.defaults.withCredentials = true;


axios.interceptors.request.use(
    (config) => {
        const token = Cookies.get("Authorization");
        if (token) {
            config.headers.Authorization = token;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            Cookies.remove("Authorization");
            const loginPath = `${process.env.PUBLIC_URL}/login`;
            if (window.location.pathname !== loginPath) {
                window.location.href = loginPath;
            }
        }
        return Promise.reject(error);
    }
);
